import { Plus, Settings, Calendar } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Button } from "../ui/button";

export default function Header({
  selectedMonth,
  onMonthChange,
  availableMonths,
  formatMonthLabel,
  onOpenCapture,
  onOpenSettings,
}) {
  return (
    <header className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-testid="header">
      {/* Logo */}
      <div className="flex items-center gap-3">
        <img src="/logo.svg" alt="CargoDash" className="h-10" />
      </div>

      {/* Controls */}
      <div className="flex items-center gap-3">
        {/* Month Selector */}
        <Select value={selectedMonth} onValueChange={onMonthChange}>
          <SelectTrigger 
            className="w-[180px] bg-white border-[#E2E8F0] text-[#0F172A]"
            data-testid="month-selector"
          >
            <Calendar className="w-4 h-4 mr-2 text-[#64748B]" />
            <SelectValue placeholder="Select month" />
          </SelectTrigger>
          <SelectContent className="bg-white border-[#E2E8F0]">
            {availableMonths.map((month) => (
              <SelectItem
                key={month}
                value={month}
                className="text-[#0F172A] hover:bg-[#F1F5F9] focus:bg-[#F1F5F9]"
              >
                {formatMonthLabel(month)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* Add Data Button */}
        <Button
          onClick={onOpenCapture}
          className="bg-[#0891B2] hover:bg-[#0E7490] text-white font-semibold gap-2"
          data-testid="add-data-btn"
        >
          <Plus className="w-4 h-4" />
          <span className="hidden sm:inline">Add Data</span>
        </Button>

        {/* Settings Button */}
        <Button
          onClick={onOpenSettings}
          variant="outline"
          className="bg-white border-[#E2E8F0] text-[#64748B] hover:bg-[#F1F5F9] hover:text-[#0F172A]"
          data-testid="settings-btn"
        >
          <Settings className="w-4 h-4" />
        </Button>
      </div>
    </header>
  );
}
